import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { Post } from 'Xhr/Xhr';
import { env } from 'env';

export const ResetPassword = async (
  data,
  navigate,
  languageArray,
  resetPasswordMsg,
  fillEmptyMsg
) => {
  const resolvedData = await data;
  if (resolvedData.UserName && resolvedData.Mobile) {
    return Post(
      'POST',
      `${process.env.REACT_APP_API_URL_API_RESET_PASSWORD}`,
      true,
      {
        ...data,
      }
    ).then((response) => {
      console.log('response reset pass =>', response);

      response.data.resCode === 1
        ? SwalAlert(
            'success',
            response.data.resMessage,
            false
          )
        : SwalAlert(
            'error',
            response.data.resMessage,
            false
          );
    });
  } else {
    SwalAlert('warning', fillEmptyMsg, false);
  }
};
